/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/lenta/:id(\d+)'>.
 * Regex-параметр :id(\d+) эмулируется numericIdShell: не-число → 404.
 */
import { createFileRoute, notFound } from '@tanstack/react-router';
import { numericIdShell } from '../compat/shells';
import Article from '@routes/Article';
import { getQueryClient } from '../../providers/query';
import { articleByIdQueryOptions } from '@queries/index';
import { isContentNotFoundError } from '../../api/contentNotFound';

export const Route = createFileRoute('/lenta/$id')({
  /**
   * ЭТАП 2 — честный 404 несуществующей статьи: бэк (articlesResolver
   * .getArticleById) кидает CONTENT_NOT_FOUND -> notFound() -> HTTP 404 +
   * контент /404 без редиректа. Лоадеры TanStack параллельны root-префетчу ->
   * await ensureQueryData (дедуп по ключу; id СТРОКОЙ — как в ключе
   * компонента; серверный клиент с retry:false). Не-числовой id — 404 сразу.
   * Клиентскую навигацию не блокируем.
   */
  loader: async ({ params }) => {
    if (!/^\d+$/.test(params.id)) {
      throw notFound();
    }
    if (typeof window !== 'undefined') {
      return;
    }
    const queryClient = getQueryClient();
    const options = articleByIdQueryOptions(params.id);
    // Префетч успел упасть раньше — ошибка уже в кэше, без второго запроса
    const settled = queryClient.getQueryState(options.queryKey);
    if (settled?.error) {
      if (isContentNotFoundError(settled.error)) {
        throw notFound();
      }
      return;
    }
    try {
      await queryClient.ensureQueryData(options);
    } catch (error) {
      if (isContentNotFoundError(error)) {
        throw notFound();
      }
    }
  },
  component: numericIdShell(Article, '/lenta/:id(\\d+)')
});
